import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

//通用样式
import './assets/css/common.scss'

//引入自定义过滤器
import './common/filters.js'

Vue.config.productionTip = false
Vue.use(ElementUI, {size: 'small', zIndex: 3000});

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

//百度统计代码
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?326ef7b17dcd4add00d9b91836b74773";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

//2.使用router.beforeEach对路由进行遍历，设置title
router.beforeEach((to, from, next) => {
    //统计代码
    if (_hmt) {
        if (to.path) {
            _hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }

    // //beforeEach是router的钩子函数，在进入路由前执行
    // if (to.meta.title) {
    //     //判断是否有标题
    //     document.title = to.meta.title
    // } else {
    //     document.title = '事件风暴'
    // }
    next()
})

window.$vue = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
